import { render, staticRenderFns } from "./compToMore.vue?vue&type=template&id=7e8a58fd&scoped=true"
import script from "./compToMore.vue?vue&type=script&lang=js"
export * from "./compToMore.vue?vue&type=script&lang=js"
import style0 from "./compToMore.vue?vue&type=style&index=0&id=7e8a58fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8a58fd",
  null
  
)

export default component.exports